//how to build and deploy
// npm run build
// firebase deploy


//import React, { Component } from "react";
import React, { FC, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom"

// Material-UI
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import ToolBar from '@material-ui/core/ToolBar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import "./App.css";

import Home from './Home';
import Mint from './Mint';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },

    siteTitle: {
        fontSize: 100,
        textAlign: 'center'
    },

    navBar: {
        alignSelf: 'center'

    }
}));

const App: FC = ({ children }) => {
    const classes = useStyles();

    //state = { web3: null, accounts: null, contract: null, tokenNum: 0, tokens: [], debug: '' };

    useEffect(() => {
    }, []);
    
    return (
        <Router>
            <div className={classes.root}>
                <AppBar className={classes.mainMenu} position="static" color="default" >
                    <div>
                        <a href="https://twitter.com/THRONEZ__NFT"><i class="fa fa-twitter"></i></a>
                    </div>
                    <h1 className={classes.siteTitle}>THRONEZ</h1>
                    <ToolBar className={classes.navBar}>
                        <Typography variant="h6" color="inherit">
                            <NavLink className="nav-link" to="/">Home</NavLink>
                        </Typography>
                        <Typography variant="h6" color="inherit">
                            <NavLink className="nav-link" to="/mint/">Mint</NavLink>
                        </Typography>
                    </ToolBar>
                </AppBar>

                <Route path="/" exact component={Home} />
                <Route path="/mint/" component={Mint} />
            </div>
        </Router>
        //<Button variant="contained" className={classes.button}>
        //    {children}
        //</Button>
        //<div className="App">
        //    <h1>THRONEZ</h1>
        //    <h2>YourWallet : {this.state.accounts}</h2>
        //    <h2>You have : {this.state.tokenNum} THRN</h2>
        //    {this.state.tokens}
        //    {this.state.debug}
        //</div>
    );
    //}
}

export default App;
